module.exports = __webpack_public_path__ + "static/media/icon_data_top_main.098a4714.png";